export enum ShareRegistryProvider {
    None = 0,
    Automic = 1,
    Xcend = 2,
    Computershare = 3,
    MUFG = 4,
    Advanced = 5,
    Boardroom = 6
}
